.card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  border: 1px solid var(--color-border-subtle);
  border-radius: var(--radius-lg);
  background: var(--color-bg);
}

.cardLayer {
  border-color: transparent;
  background: var(--color-layer-1);
}

.cardHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: var(--space-2) var(--space-4);
  padding: var(--space-4) var(--space-5) 0;
}

.cardTitle {
  font-size: var(--type-heading-md-size);
  line-height: var(--type-heading-sm-line);
  font-weight: var(--weight-semibold);
}

.cardDescription {
  margin-top: var(--space-1);
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.cardActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.cardBody {
  padding: var(--space-4) var(--space-5) var(--space-5);
}

.cardBodyFlush {
  padding: var(--space-4) 0 0;
}

.cardFooter {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: var(--space-3);
  padding: var(--space-3) var(--space-5);
  border-top: 1px solid var(--color-border-soft);
}

.pageHeader {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: space-between;
  gap: var(--space-4) var(--space-6);
  padding-bottom: var(--space-6);
}

.pageTitleBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
  max-width: 72ch;
}

/* Заголовок страницы: 24 / 1.25, вес 600 (DESIGN.md 1.3). */
.pageTitle {
  font-size: var(--type-page-title-size);
  line-height: 1.25;
  font-weight: var(--weight-semibold);
  letter-spacing: var(--tracking-title);
  overflow-wrap: anywhere;
}

.pageDescription {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.pageMeta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--space-2);
}

.pageActions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.avatar {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: 50%;
  background: var(--color-avatar-bg);
  color: var(--color-avatar-text);
  font-weight: var(--weight-semibold);
  letter-spacing: 0;
  user-select: none;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.avatarSm {
  width: 24px;
  height: 24px;
  font-size: 10px;
}

.avatarMd {
  width: 32px;
  height: 32px;
  font-size: 12px;
}

.avatarLg {
  width: 48px;
  height: 48px;
  font-size: 16px;
}

.kv {
  display: grid;
  grid-template-columns: minmax(120px, 36%) minmax(0, 1fr);
  gap: 0;
}

.kvStacked {
  grid-template-columns: minmax(0, 1fr);
}

.kvRow {
  display: contents;
}

.kvTerm,
.kvValue {
  padding: 10px 0;
  border-bottom: 1px solid var(--color-border-soft);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}

.kvTerm {
  padding-inline-end: var(--space-4);
  color: var(--color-text-secondary);
}

.kvValue {
  display: flex;
  align-items: flex-start;
  gap: var(--space-2);
  min-width: 0;
  color: var(--color-text-primary);
  overflow-wrap: anywhere;
}

.kvStacked .kvTerm {
  padding-bottom: 0;
  border-bottom: 0;
}

.kvEmpty {
  color: var(--color-text-helper);
}

.kvCopy {
  flex-shrink: 0;
  margin-top: -8px;
  margin-bottom: -8px;
}

.timeline {
  display: flex;
  flex-direction: column;
}

.timelineItem {
  position: relative;
  display: grid;
  grid-template-columns: 20px minmax(0, 1fr);
  gap: var(--space-3);
  padding-bottom: var(--space-5);
}

.timelineItem:last-child {
  padding-bottom: 0;
}

.timelineItem::before {
  content: '';
  position: absolute;
  top: 22px;
  bottom: 2px;
  left: 9px;
  width: 2px;
  background: var(--color-border-subtle);
}

.timelineItem:last-child::before {
  display: none;
}

.timelineMarker {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-top: 2px;
}

.timelineDot {
  width: 10px;
  height: 10px;
  border: 2px solid var(--color-border-strong);
  border-radius: 50%;
  background: var(--color-bg);
}

.timelineBody {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  min-width: 0;
}

.timelineHead {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-1) var(--space-3);
}

.timelineTitle {
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  font-weight: var(--weight-semibold);
}

.timelineTime {
  color: var(--color-text-helper);
  font-size: var(--type-caption-size);
  line-height: var(--type-caption-line);
  font-variant-numeric: tabular-nums;
}

.timelineText {
  color: var(--color-text-secondary);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
}
